import { AppVariants } from '@store/models/generic.model';

const ACTION_SCOPE = '[DOE generic]';

export class GetAppVariant {
  static readonly type = `${ACTION_SCOPE} Get app variant`;
}

export class SetAppVariant {
  static readonly type = `${ACTION_SCOPE} Set app variant`;
  constructor(public variant: AppVariants) {}
}
